import {
  MeterUploadRowStatus,
  type MeterUploadRow,
  type MeterUploadRowData,
} from "./buildTrialRunRow";
import { newRowId } from "./newRowId";

// A blank row for a freshly inserted inline row. Identity / lookup fields start
// empty — the operator fills them in via the inline cells — while reading defaults
// to 0 and seq is left unset. Returned as a fresh object each call so two inserted
// rows never share a reference.
export const emptyRowData = (): MeterUploadRowData => ({
  accountNumber: "",
  extractionPointName: "",
  serialNo: "",
  readAt: "",
  reading: 0,
  group: "",
  seq: undefined,
});

// Wrap row data in a not-yet-persisted Draft row with a fresh client id. Used to
// insert a blank editable row inline; the standalone add-row modal is retired.
export const buildNewRow = (
  rowData: MeterUploadRowData = emptyRowData(),
): MeterUploadRow => ({
  id: newRowId(),
  rowData,
  status: MeterUploadRowStatus.Draft,
});
